// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__C8jES","theme":"navbar_theme__4cJCc","icon":"navbar_icon__-z0mA"};